import ip from 'ip';
import UAParser from 'ua-parser-js';
import { isAcme } from 'isAcme';
import type { AuthSession } from 'utils/auth/types';

const userAgentParser = new UAParser();
const isMobileDevice = typeof window !== 'undefined' && userAgentParser.getDevice().type === 'mobile';
const isTabletDevice = typeof window !== 'undefined' && userAgentParser.getDevice().type === 'tablet';

export default function buildUser(authSession: AuthSession) {
  let device;
  if (isMobileDevice) {
    device = 'mobile';
  } else if (isTabletDevice) {
    device = 'tablet';
  } else {
    device = 'desktop';
  }

  // other user keys (could get from profile):
  //   email         profile.username or profile.primaryEmail.address
  //   name
  //   firstName     profile.firstName
  //   lastName      profile.lastName
  const key = authSession && authSession.qcsId;
  return ({
    key: key || 'anon',
    ip: ip.address(),
    custom: {
      'browser-name': userAgentParser.getResult().browser.name,
      'browser-version': userAgentParser.getResult().browser.version,
      'device-type': device,
      'project': process.env.PROJECT,

      'dataset-id': authSession.datasetId,
      'dataset-platform': authSession.datasetPlatform,
      'dataset-created-by-client-id': authSession.datasetCreatedByClientId,
      'scopes': authSession.scopes,
      'client-type': isAcme ? 'Simplifi Web App' : 'Quicken Web App',
    },
  });
}

